module.exports = __webpack_public_path__ + "static/media/10C.1b2da05d.svg";